import { Box } from '@mui/material';
import { Button } from '@globalvisioninc/ui/button';
import { Pipette } from '@globalvisioninc/assets/icons';
import { useDispatch, useSelector } from 'react-redux';
import { inspection, getInspectionSettings, getSelectedTool, getTextProcessStatus } from 'store';
import GVCheckbox from 'components/lib/GVCheckbox/GVCheckbox';
import { DocumentTypes, PDFTronTools, PDFTRON_DEFAULT_TOOL } from 'types';
import { PDFManagerFactory } from 'pdftron';
import { useDocumentToastStateStore } from 'zstore/documentToastStateStore';
import selectTool from 'utils/selectTool/selectTool';
import toastEvents, { ToastTypes } from 'components/DocumentToast/toastEvents';
import styles from './ColorCheckSettings.module.css';

const ColorCheckSettings = () => {
  const dispatch = useDispatch();
  const inspectionSettings = useSelector(getInspectionSettings);
  const selectedTool = useSelector(getSelectedTool);
  const documentProcessed = useSelector(getTextProcessStatus);
  const setDocumentToast = useDocumentToastStateStore((s) => s.setDocumentToast);
  const expireDocumentToast = useDocumentToastStateStore((s) => s.expireDocumentToast);

  const isPicking = !!inspectionSettings.colorCheck && selectedTool === PDFTronTools.COLOR_PICKER;

  const toggleColorCheck = () => {
    const turningOn = !inspectionSettings.colorCheck;

    if (turningOn) {
      dispatch(inspection.actions.setInspectionSettings({ colorCheck: true }));
    } else {
      dispatch(inspection.actions.setInspectionSettings({ colorCheck: false }));
      selectTool(PDFTRON_DEFAULT_TOOL);
      const pdfDocManager = PDFManagerFactory.getPDFDocManager();
      pdfDocManager?.tools.colorPicker?.clearAllColorPoints();
      expireDocumentToast(DocumentTypes.target, { ...toastEvents[ToastTypes.COLOR_CHECK], expired: false });
      pdfDocManager?.cleanDocumentHighlight();
    }
  };

  const togglePickingMode = () => {
    if (isPicking) {
      selectTool(PDFTRON_DEFAULT_TOOL);
      expireDocumentToast(DocumentTypes.target, { ...toastEvents[ToastTypes.COLOR_CHECK], expired: false });
    } else {
      const pdfDocManager = PDFManagerFactory.getPDFDocManager();
      if (!pdfDocManager?.canChangeTools(PDFTronTools.COLOR_PICKER)) {
        selectTool(PDFTronTools.COLOR_PICKER);
        return;
      }
      setDocumentToast(DocumentTypes.target, { ...toastEvents[ToastTypes.COLOR_CHECK], expired: false });
      selectTool(PDFTronTools.COLOR_PICKER);
    }
  };

  return (
    <div className={styles.root}>
      <GVCheckbox
        checked={!!inspectionSettings.colorCheck}
        onChange={toggleColorCheck}
        label={
          <Box component="span" data-testid="colorcheck_label">
            Color Check
          </Box>
        }
        data-testid="colorcheck_enable"
        disabled={!documentProcessed}
      />
      {inspectionSettings.colorCheck && (
        <Button.Root
          elementStart={<Pipette />}
          onClick={togglePickingMode}
          mode="secondary"
          data-testid="colorcheck_select_points"
          isDisabled={!documentProcessed}
        >
          {isPicking ? 'Exit selection' : 'Select points'}
        </Button.Root>
      )}
    </div>
  );
};

export default ColorCheckSettings;
